var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPickUpPoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pick up point") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offres-CnC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Distribuer-Copy-5",
    transform: "translate(-33.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "place_black_24dp-(1)",
    transform: "translate(33.000000, 450.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12 C10.9,12 10,11.1 10,10 C10,8.9 10.9,8 12,8 C13.1,8 14,8.9 14,10 C14,11.1 13.1,12 12,12 Z M18,10.2 C18,6.57 15.35,4 12,4 C8.65,4 6,6.57 6,10.2 C6,12.54 7.95,15.64 12,19.34 C16.05,15.64 18,12.54 18,10.2 Z M12,2 C16.2,2 20,5.22 20,10.2 C20,13.52 17.33,17.45 12,22 C6.67,17.45 4,13.52 4,10.2 C4,5.22 7.8,2 12,2 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPickUpPoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pick-up-point.18e8f662a368d7a174bae3d8150b9fe0.svg";